import { render, staticRenderFns } from "./BannerData.vue?vue&type=template&id=1ad25733&scoped=true"
import script from "./BannerData.vue?vue&type=script&lang=js"
export * from "./BannerData.vue?vue&type=script&lang=js"
import style0 from "./BannerData.vue?vue&type=style&index=0&id=1ad25733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad25733",
  null
  
)

export default component.exports